import React from 'react'
import { FaCamera, FaTimes } from "react-icons/fa";
import { FaVideo } from "react-icons/fa";
import { InputContainer } from '../../../../common/components/form/input/containers/input.container'
import { HiOutlineTrash } from 'react-icons/hi';
import { CollectionModalComponet } from '../../../../models/collection-modal';


export default function TenantWebsitesCardBasicInfo ({isModalOpen,isModalProductOpen,handleOpenModal,handleCloseModal,setPageData,
  additionButtons,onSelect,categoryColumnDefs,productsPaginationData,productColumnDefs,categories,products,categoriesPaginationData,handleOpenProductModal,handleCloseProductModal,deleteTenantwebCardItem,changeCardFile,handleFormChange,cardValues,cardTemplate}: any) {

  return (
    <> 
      <div className="flex justify-end">
 {cardValues[0]?.product  && (
                      <button onClick={handleOpenProductModal} type="button" className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3">
                        Add Products
                      </button>
                    )}
                    {cardValues[0]?.category && (
                      <button onClick={handleOpenModal} type="button" className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3">
                        Add Categories
                      </button>
                    )}</div>
  <div className="h-[500px] overflow-auto w-full bg-white shadow-xl p-4 rounded">
  <table className="w-full text-xs bg-red-50">
    <thead className="w-full border-y border-black border-opacity-20">
      <tr className="w-full text-left h-12">
        {cardTemplate.map((template: any) => (
          <th key={template.field} className="px-5">{template.field}</th>
        ))}
        <th className="border-r-2  last:border-r-0 w-auto px-10">Action</th>
      </tr>
    </thead>
    <tbody className="w-full bg-red-400 h-[400px]">
      {cardValues.map((cardData: any, index: any) => (
     <tr key={index} className={`${
      index % 2 === 0 ? 'bg-blue-100' : 'bg-white'
    } `}>
          {cardTemplate.map((template: any) => (
            <td key={`${template.field}-${index}`} 
            className="px-6 py-4  w-auto">
             {!cardValues[0]?.product && ! cardValues[0]?.category&& template.type === 'text' &&
                      <InputContainer
                          onValueChange={(event: any) => {
                            handleFormChange({
                              value: event.target.value,
                              field: template.field,
                              idx: index
                            })
                          }}
                          type={template.type}
                          value={cardData[template.field]}
                      />}
                        {(cardValues[0]?.product|| cardValues[0]?.category) && template.type === 'text' &&
                      <InputContainer
                      isDisabled
                      showToolTip
                          onValueChange={(event: any) => {
                            handleFormChange({
                              value: event.target.value,
                              field: template.field,
                              idx: index
                            })
                          }}
                          type={template.type}
                          value={cardData[template.field]}
                      />}
                       {template.type === 'checkbox' &&
                      <InputContainer
                          onValueChange={(event: any) => {
                            handleFormChange({
                              value: event.target.value,
                              field: template.field,
                              idx: index
                            })
                          }}
                          type={template.type}
                          value={cardData[template.field]}
                      />}
                 {template.type === 'image' &&
                      <>
                             <img
                                 src={cardData[template.field]}
                                 className="w-12 h-12"
                               
                             />
<button
    onClick={() => changeCardFile(
      index,
      template.field,
      'image'
    )}
>
<FaCamera className="ml-4" />
</button>
</>} 
{template.type === 'video' &&
                      <>
                       <video
                           src={cardData[template.field]}
                           className="w-12 h-12"
                       />
<button
    color="primary"
    onClick={() => changeCardFile(
      index,
      template.field,
      'video'
    )}
>
<FaVideo className="ml-4" />
</button>
</>}    
{template.type === 'product' && (
                   <div className="m-2 flex items-center">
                   <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     viewBox="0 0 24 24"
                   >
                     <path
                       d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                       fill="currentColor"
                     />
                   </svg>
                 </div>
                    )}
                    {template.type === 'category' && (
                      <div className="m-2 flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"
                          fill="currentColor"
                        />
                      </svg>
                    </div>
                    )}
            </td>
          ))}
          <td key={9} className="flex px-5 w-max flex-row justify-start item-baseline cursor-pointer pt-6 space-x-2">
                  <button className="text-red-500 hover:text-red-700" onClick={async () => deleteTenantwebCardItem(cardData, index)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>
                </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
<CollectionModalComponet
isModalOpen={isModalOpen}
handleCloseModal={handleCloseModal}
categoryColumnData={categoryColumnDefs}
categoryRowData={categories}
setPageData={setPageData}
categoriesPaginationData={categoriesPaginationData}
onSelect={onSelect} 
additionButtons={additionButtons}
productColumnData={productColumnDefs}
productRowData={products}
productsPaginationData={productsPaginationData}
isModalProductOpen={isModalProductOpen}
handleCloseProductModal={handleCloseProductModal}
/>
</>
  )
}